// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogZhCN = {
  "controls": {
    "boot": "启动",
    "reset": "重置",
    "copyScreen": "复制屏幕",
    "copyText": "复制文本",
    "pasteText": "粘贴文本",
    "saveState": "保存状态",
    "restoreState": "恢复状态",
    "toggleSound": "切换音效",
    "retrySound": "声音不可用。请重试声音。",
    "settings": "设置",
    "debugPanel": "调试面板",
    "infoPanel": "信息面板",
    "reportIssue": "报告问题",
    "privacyPolicy": "隐私政策"
  },
  "config": {
    "speed": "模拟器速度",
    "display": "显示设置",
    "theme": "主题",
    "openRetroControlPanel": "控制面板",
    "resetSettings": "重置所有设置",
    "capsLock": "大写锁定",
    "useOpenApple": "将 {{modKey}} 键用作 Open Apple 键",
    "useShortcuts": "将 {{modKey}} 键用于键盘快捷键",
    "useArrowKeys": "使用方向键作为摇杆",
    "scanlines": "CRT 扫描线",
    "ghosting": "屏幕残影",
    "crtDistortion": "CRT 失真效果",
    "joystick": "摇杆设置"
  },
  "machine": {
    "configuration": "机器配置",
    "slotConfigurator": "扩展插槽",
    "models": {
      "apple2eu": "Apple IIe (未增强)",
      "apple2ee": "Apple IIe (增强版)"
    },
    "ram": {
      "64kb_aux": "64 KB (AUX)",
      "512kb": "512 KB",
      "1024kb": "1024 KB",
      "4mb": "4 MB",
      "8mb": "8 MB"
    }
  },
  "speed": {
    "snail": "蜗牛速度 (0.1 MHz)",
    "slow": "慢速 (0.5 MHz)",
    "normal": "正常速度 (1 MHz)",
    "fast": "快速 (4 MHz)",
    "warp": "极速"
  },
  "colors": {
    "color": "彩色",
    "nofringe": "彩色 (无边缘)",
    "green": "绿色",
    "amber": "琥珀色",
    "white": "黑白",
    "inverse": "黑白 (反色)"
  },
  "themes": {
    "classic": "经典",
    "dark": "深色",
    "minimal": "简约"
  },
  "debug": {
    "helpPanel": "显示帮助面板",
    "debugPanel": "显示调试面板",
    "expectinPanel": "显示 Apple exPectin 面板",
    "helpTab": "帮助",
    "debugTab": "调试",
    "breakpoints": "断点",
    "memory": "内存",
    "stack": "堆栈",
    "state": "CPU 状态",
    "registers": "寄存器",
    "flags": "标志",
    "step": "单步执行",
    "stepOver": "步过",
    "stepInto": "步入",
    "stepOut": "步出",
    "resume": "恢复",
    "pause": "暂停",
    "loadSymbolTable": "加载符号表",
    "agentTab": "AI 代理",
    "disassembly": "反汇编"
  },
  "disassembly": {
    "cassette": {
      "toggleOutput": "切换卡带输出"
    },
    "speaker": {
      "toggleOutput": "切换扬声器输出"
    },
    "notice": {
      "noWriteEffect": "信息：此写操作对{{machine}}毫无作用"
    },
    "display": {
      "selectTextMode": "选择文本模式"
    }
  },
  "tour": {
    "welcome": "欢迎使用 Apple2TS 模拟器！",
    "clickNext": "若要了解更多，请按下一步按钮。",
    "bootButton": "按这里启动模拟器。",
    "resetButton": "点击此处重置 Apple II，并重新启动或进入 BASIC。",
    "diskImages": "选择其中一个已安装的磁盘映像文件。",
    "floppyDisks": "或点击一下软盘图标来加载磁盘映像文件。",
    "retroFloppyDisks": "或选择一个磁盘驱动器加载磁盘映像。",
    "saveRestore": "您可以使用这些按钮保存和恢复模拟器的完整状态。",
    "retroSaveRestore": "您可以使用这些选项保存和恢复模拟器的完整状态。",
    "themeButton": "点击这里更改模拟器 UI 主题。",
    "endTour": "您已到达导览的结尾。",
    "tourSelectorHint": "点击地球仪导览按钮来试试其他导览，或按完成开始使用模拟器。",
    "settingsWelcome": "Apple2TS 拥有一套完整的控制项，用于模拟器和 Apple II。",
    "mainControls": "在这里，您可以启动和重置 Apple II，恢复和保存状态，复制屏幕，或粘贴文本到模拟器。",
    "snapshot": "在任何时候，您都可以截取当前模拟器状态的快照，然后回到早期状态，或再次快进。您也可以将模拟器状态与所有当前的快照一起保存。",
    "pauseButton": "您可以随时暂停模拟器，冻结 6502 处理器。这对于暂停游戏中的动作或进入调试器很有用。",
    "debugButton": "按一下调试器图标进入调试模式，您可以查看 6502 处理器的内部状态。再次按一下即可回到正常模式。",
    "configButtons": "底部一排按钮控制 Apple II 的状态，以模拟器速度、屏幕颜色和静音为起始。",
    "keyboardButtons": "如果开启了大写锁定键，然后所有输入的字符都是大写的。",
    "altArrowKeys": "下一个按钮决定 {{modKey}} 键是用于键盘快捷键还是 Apple II Open Apple 键。最后一个按钮决定是否可以使用方向键作为 Apple II 的摇杆。",
    "clearCookies": "Apple2TS 会自动将当前的模拟器设置保存为浏览器 cookie。按下此按钮可重置这些设置并删除 cookie。",
    "debugWelcome": "Apple2TS 拥有一套丰富的工具来分析和调试 6502 汇编代码。若要了解更多，请按下一步按钮。",
    "debugIcon": "按一下信息页签上的调试器图标以查看调试面板。",
    "debugPause": "按下暂停按钮以暂停或恢复模拟器的执行。",
    "debugControls": "现在我们已经暂停了，我们可以使用「跳越执行」、「进入」和「跳出执行」按钮逐步执行反汇编代码。我们也可以快速跳转到程序计数器 (PC) 的当前地址。",
    "debugDisassembly": "在这里我们可以看到反汇编代码，包括十六进制地址、三个字母的指令，以及任何数值或地址。如果您将鼠标移动到绿色数值上，将会出现一个工具提示，显示当前的数值。按一下蓝色地址将滚动到该位置。您也可以按一下左侧的栏位来添加或移除断点。",
    "debugInfo": "在中间我们有堆栈转储和内存映射。内存映射会实时更新，并显示当前使用中的内存组块。",
    "debugMemory": "最后一部分显示 Apple II 的内存。您可以使用下拉列表来检查内存的不同部分。如果您切换到其中一个 HGR 页面，您将得到放大的高分辨率屏幕视图，与内存位置连接。您也可以搜索十六进制数值或 ASCII 字符串，并将内存保存到文件中。",
    "back": "上一步",
    "close": "关闭",
    "last": "完成",
    "next": "下一步",
    "nextLabelWithProgress": "下一步 (第 {step} 步，共 {steps} 步)",
    "skip": "关闭",
    "guidedTour": "引导式导览",
    "mainLabel": "引导式导览：主要",
    "settingsLabel": "引导式导览：设置",
    "debugLabel": "引导式导览：调试"
  },
  "disk": {
    "drive1": "磁盘驱动器 1",
    "drive2": "磁盘驱动器 2",
    "hardDisk": "硬盘",
    "eject": "弹出磁盘",
    "insert": "插入磁盘",
    "writeProtected": "写保护",
    "readWrite": "读/写",
    "empty": "空的",
    "loading": "加载中...",
    "selectDisk": "选择磁盘映像文件",
    "browse": "浏览",
    "newReleases": "新发行版",
    "writeProtectDisk": "磁盘写保护",
    "saveDiskToDevice": "保存磁盘",
    "saveDiskTo": "保存磁盘到",
    "saveDiskToMenu": "保存磁盘到 >",
    "addToFavorites": "添加到收藏夹",
    "downloadDisk": "下载磁盘",
    "downloadWoz": "下载 WOZ 磁盘映像",
    "downloadAndEjectDisk": "下载并退出磁盘",
    "ejectDisk": "退出磁盘",
    "ejectAllDisks": "退出全部磁盘",
    "saveDiskToOneDrive": "保存磁盘到 OneDrive",
    "saveDiskToGoogleDrive": "保存磁盘到 Google Drive",
    "loadDisk": "加载磁盘",
    "loadAdditionalDisks": "加载附加磁盘...",
    "loadDiskFrom": "从以下位置加载磁盘",
    "loadDiskFromMenu": "从以下位置加载磁盘 >",
    "loadDiskFromDevice": "加载磁盘",
    "loadDiskFromDeviceReadOnly": "从设备加载磁盘 (只读)",
    "loadDiskFromDeviceReadWrite": "从设备加载磁盘 (读写)",
    "loadDiskFromInternetArchive": "从 Internet Archive 加载磁盘",
    "loadDiskFromOneDrive": "从 OneDrive 加载磁盘",
    "loadDiskFromGoogleDrive": "从 Google Drive 加载磁盘",
    "insertBlankDisk": "插入空白磁盘",
    "syncEveryMinute": "每分钟同步",
    "syncEvery5Minutes": "每 5 分钟同步",
    "pauseSyncing": "暂停同步",
    "syncNow": "立即同步",
    "modified": "已修改",
    "synced": "已同步",
    "diskImage": "磁盘映像",
    "diskDrivesAndDevices": "磁盘驱动器与设备",
    "syncedAt": "同步于 {{date}}",
    "clickToLoadDiskImage": "点击加载磁盘映像",
    "clickToRemoveFromDiskCollection": "点击从磁盘收藏移除",
    "clickToAddToDiskCollection": "点击加入磁盘收藏",
    "byCreator": "作者：{{creator}}",
    "clickToViewDetails": "点击查看详情",
    "standbyDisks": "备用磁盘 (点击更换磁盘)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "TypeScript Apple IIe 模拟器",
    "credit": "(c) {{year}} Chris Torrence 和 Apple2TS 贡献者",
    "keyboardShortcuts": "键盘快捷键",
    "shortcutsUnavailable": "当 {{keyMod}} 键被指定为 Open Apple 时，使用该键的模拟器快捷键不可用。Ctrl+0 到 Ctrl+5 仍可选择模拟器速度。",
    "diskImages": "磁盘映像文件：",
    "diskContainers": "压缩封装包：",
    "multiDiskNotice": "多磁盘置换：点击磁盘图标上的多盘标签可打开快速置换菜单。加载多磁盘压缩包 (.zip, .7z, .gz) 会自动将所有磁盘载入置换列表。",
    "urlParameters": "可选的 URL 参数",
    "examples": "示例",
    "mobileInstructions": "移动平台：",
    "tapScreen": "点击屏幕以显示键盘。",
    "arrowKeys": "按方向键、ESC 或 Tab 按钮将这些按键发送到模拟器。",
    "ctrlKey": "要发送控制字符，请按一次 Ctrl 按钮。然后点击屏幕显示键盘并按所需的按键。Ctrl 按钮将自动释放。",
    "ctrlLock": "要发送多个控制字符，请按两次 Ctrl 按钮以锁定（以绿点表示）。然后点击屏幕显示键盘并按所需的按键。再次按 Ctrl 按钮以释放。",
    "appleKeys": "Open Apple 和 Closed Apple 键的行为与 Ctrl 键相同。",
    "openAppleKey": "Open Apple: 按左侧 Alt/Option",
    "closedAppleKey": "Closed Apple: 按右侧 Alt/Option",
    "joystickKeys": "摇杆按键: 右侧数字键 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "屏幕键盘：使用CTRL或ESC键时，\n点击一次启用，然后点击所需的按键。",
    "urlParametersBody": "对于可选的URL参数，在URL后面加上问号(?)并附加参数，多个参数之间用(&)符号分隔。使用#指定磁盘镜像。有关示例，请参阅链接生成器对话框。",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay (含调试)",
      "totalReplayChoplifter": "Total Replay (加载 Choplifter，嵌入模式)",
      "a2Desktop": "A2Desktop 2MG (快速，彩色)",
      "embeddedBasic": "嵌入式 Applesoft BASIC 程序",
      "binaryHexAddress": "具有十六进制地址的二进制文件"
    },
    "links": "链接",
    "resourceLinks": {
      "desktopApp": "Apple2TS 桌面应用程序",
      "corsProxy": "Corsfix 提供的 CORS 代理",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "加载中...",
    "error": "错误",
    "success": "成功",
    "confirm": "确认",
    "cancel": "取消",
    "ok": "确定",
    "on": "开启",
    "off": "关闭",
    "confirmTheme": "重新加载模拟器并立即应用此主题吗？",
    "confirmReset": "将所有设置重置为默认值吗？",
    "fileNotFound": "找不到文件",
    "invalidFile": "无效的文件格式",
    "diskInserted": "已插入磁盘",
    "diskEjected": "已退出磁盘"
  },
  "keyboard": {
    "capsLock": "大写锁定",
    "space": "空格键",
    "backspace": "退格",
    "delete": "删除"
  },
  "audio": {
    "speaker": "扬声器",
    "midi": "MIDI",
    "configuration": "音讯设置",
    "volume": "音量",
    "mute": "静音",
    "waveform": "波形"
  },
  "print": {
    "printer": "打印机",
    "print": "打印",
    "clear": "清除",
    "save": "保存输出",
    "dumpScreen": "将当前屏幕发送到打印机",
    "dumpScreenInverse": "将当前屏幕发送（反色）",
    "sendToPrinter": "发送到打印机",
    "tearOff": "撕下页面并重置",
    "printedPage": "已打印页面",
    "printerConfig": "打印机配置",
    "pageLength": "页面长度",
    "pageLengthLetter": "11英寸（信纸）",
    "pageLengthA4": "11.7英寸（A4）",
    "pageLengthTwelve": "12英寸"
  },
  "device": {
    "machineConfiguration": "机器配置",
    "midiDeviceSelect": "MIDI 设备选择",
    "serialPortSelect": "串口选择",
    "mockingboardWaveform": "Mockingboard 波形"
  },
  "collection": {
    "showApple2TSCollection": "显示 Apple2TS 收藏",
    "showNewReleases": "显示新发行版",
    "showFavorites": "显示收藏夹",
    "chooseDiskImage": "选择磁盘映像",
    "diskCollection": "磁盘收藏",
    "clickToShowDetails": "点击显示详情",
    "clickToLoadDisk": "点击加载磁盘",
    "diskIsNewRelease": "磁盘是新发行版",
    "diskIsApple2TSCollection": "磁盘是 Apple2TS 收藏的一部分",
    "diskIsInternetArchive": "磁盘是 Internet Archive 的一部分",
    "clickToRemoveFromCollection": "点击从磁盘收藏中移除",
    "clickToKeepInCollection": "点击以保留在磁盘收藏中",
    "clickToAddToCollection": "点击加入磁盘收藏",
    "diskIsSyncedVia": "磁盘通过同步",
    "loadDiskIntoDrive": "加载磁盘到驱动器",
    "cloudAuthRequired": "需要验证",
    "signIn": "登录",
    "exportDisksToHdv": "将磁盘导出为HDV",
    "export": "导出",
    "clickToRemoveFromSelected": "点击从已选磁盘中移除",
    "clickToAddToSelected": "点击添加到已选磁盘",
    "reportExportIssue": "报告导出问题"
  },
  "debugControls": {
    "goBackInTime": "回到过去",
    "takeSnapshot": "拍摄快照",
    "goForwardInTime": "向前跳跃",
    "saveStateWithSnapshots": "保存状态及快照",
    "resume": "继续",
    "pause": "暂停",
    "trace": "追踪",
    "tracing": "正在追踪",
    "downloadTraceLog": "下载追踪纪录"
  },
  "fullscreen": {
    "fullScreen": "全屏"
  },
  "internetArchive": {
    "searchPlaceholder": "输入软件名称或点击上方分类",
    "go": "搜索"
  },
  "basic": {
    "newProgram": "新程序",
    "runFromBeginning": "从头开始运行",
    "break": "中断",
    "continueRunning": "继续运行",
    "stepProgram": "单步执行程序",
    "resumeOutput": "恢复输出",
    "freezeOutput": "冻结输出",
    "importProgram": "导入程序...",
    "exportProgram": "导出程序...",
    "renumberProgram": "重新编号程序",
    "rebuildProgram": "从内存重建程序",
    "displaySettings": "显示设置",
    "autoLineNumbering": "自动行号",
    "capitalizeKeywords": "关键字大写",
    "rebuildWarning": "此操作将会用从 Apple II 内存中重建的版本替换当前的程序。您将会丢失所有未保存的更改。是否确定要继续？",
    "variable": "变量",
    "value": "值"
  },
  "expectin": {
    "runScript": "运行脚本",
    "stopScript": "停止脚本"
  },
  "saveDisassembly": {
    "title": "保存反汇编",
    "startAddress": "开始地址 $",
    "endAddress": "结束地址 $",
    "includeLabels": "包含符号标签",
    "separatorLines": "在 JMP、RTS 后加入分隔线"
  },
  "gamepad": {
    "useArrowKeys": "使用方向键作为摇杆",
    "siriusJoyport": "Sirius 摇杆端口模式",
    "reverseYAxis": "反转摇杆 Y 轴"
  },
  "traceSettings": {
    "title": "追踪设置",
    "numLines": "保留的行数：",
    "rangeWarning": "必须介于 100 到 100000 之间",
    "collapseLoops": "寻找重复行并折叠循环",
    "ignoreRegisters": "寻找重复行时忽略寄存器数值",
    "settings": "设置"
  },
  "keyboardControl": {
    "hideKeyboard": "隐藏键盘",
    "showKeyboard": "显示键盘"
  },
  "linkBuilder": {
    "title": "链接生成器",
    "buttonTitle": "链接生成器",
    "userInterface": "用户界面：",
    "machine": "主机型号：",
    "colorMode": "颜色模式：",
    "ramDiskSize": "RAM 磁盘大小 (KB)：",
    "emulatorSpeed": "模拟器速度：",
    "uiTheme": "界面主题：",
    "showDebugTab": "显示调试分页",
    "sound": "音效",
    "startupOptionsTab": "启动选项",
    "onStartup": "启动时：",
    "loadDiskImage": "加载磁盘映像",
    "loadBasicProgram": "加载 BASIC 程序",
    "loadHexCode": "加载 16 进制码",
    "diskImageToLoad": "启动时加载的磁盘映像：",
    "customDiskUrl": "自定义磁盘映像网址：",
    "textToType": "加载磁盘后输入的文本：",
    "enterTextPlaceholder": "在此输入文本或 BASIC 代码",
    "runBasicAfterLoading": "加载后运行 BASIC 程序",
    "enterHexPlaceholder": "在此输入 16 进制码，例如：A9 01 8D 00 03",
    "hexLoadAddress": "16 进制加载地址：$",
    "runHexAfterLoading": "加载后运行 16 进制程序",
    "finalUrl": "最终网址：",
    "copyToClipboard": "复制到剪贴板",
    "tryIt": "尝试运行",
    "reset": "重置",
    "close": "关闭",
    "customDiskUrlOption": "自定义网址",
    "gameModes": {
      "normal": "正常",
      "game": "游戏 (无磁盘机与分页)",
      "embed": "嵌入 (隐藏所有控制项)"
    },
    "colorNames": {
      "color": "彩色",
      "nofringe": "彩色 (无边缘)",
      "green": "绿色屏幕",
      "amber": "琥珀色屏幕",
      "white": "白色屏幕",
      "inverse": "反色屏幕"
    },
    "speedNames": {
      "snail": "极慢",
      "slow": "慢速",
      "normal": "1 MHz (默认)",
      "warp": "极速"
    },
    "machines": {
      "enhanced": "Apple IIe (增强型)",
      "unenhanced": "Apple IIe (非增强型)"
    },
    "themes": {
      "classic": "经典",
      "dark": "深色",
      "minimal": "简约"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192",
      "default": "64 (默认)"
    },
    "slots": {
      "configure": "配置插槽扩展卡",
      "slot": "插槽 {{slot}}:",
      "cardNone": "无 (空)"
    },
    "additionalDiskDrives": "附加磁盘驱动器",
    "slot6Drive1": "插槽 6 驱动器 1 (软盘 1)",
    "slot6Drive2": "插槽 6 驱动器 2 (软盘 2)",
    "slot7Drive1": "插槽 7 驱动器 1 (硬盘 1)",
    "slot7Drive2": "插槽 7 驱动器 2 (硬盘 2)",
    "slot2Drive1": "插槽 2 驱动器 1 (VERA SD)",
    "slot4Drive1": "插槽 4 驱动器 1 (VERA SD)",
    "addAdditionalDisk": "添加用于更换的附加磁盘",
    "removeDisk": "移除此磁盘",
    "addAnotherDisk": "添加另一个磁盘",
    "diskPlaceholder": "磁盘 {num} 文件名 (例如 sideB.woz|剧情磁盘)"
  },
  "agent": {
    "tabTitle": "AI 代理",
    "setupTitle": "🤖 AI 代理设置",
    "setupInstruction": "点击下方的齿轮图标以配置您的 AI 助手。",
    "welcomeTitle": "欢迎使用 Apple II 助手！我可以协助您：",
    "welcomeItem1": "检查 CPU 寄存器与内存",
    "welcomeItem2": "控制执行状态（启动、重置、单步执行、断点）",
    "welcomeItem3": "加载程序与管理磁盘",
    "welcomeItem4": "调试 6502 汇编代码",
    "welcomeItem5": "读取屏幕内容与系统状态",
    "welcomePrompt": "欢迎随时向我提问！",
    "userRole": "您",
    "assistantRole": "🤖 助手",
    "inputPlaceholder": "向我询问关于 Apple II 模拟器的任何问题... (按 Enter 发送，Shift+Enter 换行)",
    "stop": "停止",
    "send": "发送",
    "changeConfiguration": "更改设置",
    "processing": "处理中...",
    "tokens": "• 输入 {{input}} / 输出 {{output}}",
    "configTitle": "配置 AI 代理",
    "provider": "提供商：",
    "model": "模型：",
    "apiKey": "API 密钥：",
    "save": "保存",
    "clear": "清除",
    "storageWarning": "您的 API 密钥会保存在本地浏览器中，绝不会发送至 apple2ts.com。获取您的 {{provider}} API 密钥：",
    "providerNotConfigured": "尚未配置提供商 - 请点击齿轮图标以配置您的 AI 代理",
    "providerConfigured": "提供商：{{provider}} ({{model}})",
    "invalidKeyFormat": "{{provider}} 的 API 密钥格式不正确"
  },
  "startup": {
    "welcome": "欢迎使用 Apple2TS",
    "subtitle": "TypeScript Apple II 模拟器",
    "copyright": "(c) {{year}} C.Torrence + 合作者",
    "diskCollections": "点击磁盘集合图标\n加载内置磁盘或游戏。"
  },
  "retroControl": {
    "machine": "机器",
    "fullscreen": "全屏",
    "diskCollection": "磁盘",
    "diskDrives": "磁盘驱动器",
    "display": "显示",
    "monitorMode": "显示器模式",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "声音",
    "options": "选项",
    "skin": "皮肤",
    "personalization": "个性化",
    "text": "文本",
    "background": "背景",
    "border": "边框",
    "iigsColor": {
      "black": "黑色",
      "red": "红色",
      "darkBlue": "深蓝色",
      "purple": "紫色",
      "darkGreen": "深绿色",
      "darkGray": "深灰色",
      "mediumBlue": "中蓝色",
      "lightBlue": "浅蓝色",
      "brown": "棕色",
      "orange": "橙色",
      "lightGray": "浅灰色",
      "pink": "粉色",
      "lightGreen": "浅绿色",
      "yellow": "黄色",
      "aquamarine": "海蓝色",
      "white": "白色"
    },
    "keyboard": "键盘",
    "joystick": "操纵杆",
    "slots": "插槽",
    "devices": "设备",
    "printerPort": "打印机端口",
    "modemPort": "调制解调器端口",
    "quit": "退出",
    "apple2tsCollection": "Apple2TS 收藏",
    "newReleases": "最新发布",
    "favorites": "收藏夹",
    "exportDisksToHdv": "将磁盘导出为 HDV",
    "noDiskDrivesAvailable": "没有可用的磁盘驱动器",
    "select": "选择",
    "open": "打开",
    "load": "载入",
    "go": "前往",
    "save": "保存",
    "clipboard": "剪贴板",
    "cancelEsc": "取消:Esc",
    "color": "颜色",
    "systemSpeed": "系统速度",
    "other": "其他",
    "timeMachine": "快照",
    "ports": "端口",
    "language": "语言",
    "retroTheme": "复古",
    "lowercaseInput": "小写输入",
    "openAppleKey": "开放苹果键",
    "sortOrder": "排序",
    "card": {
      "empty": "空",
      "mockingboard": "Mockingboard"
    }
  }
}
